// Small shared helpers used across the theme's entry points.

/** True when the visitor has asked the OS to minimise motion. */
export const reducedMotion = (): boolean =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/** HTML-escapes a string for safe interpolation into an innerHTML template. */
export function esc(value: string): string {
  const el = document.createElement('div');
  el.textContent = value;
  return el.innerHTML;
}
